import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useQueryParams } from 'utils/hooks/useQueryParams';
import { FilterParamOptions } from '../constants';
import { useTabContext, useViewContext } from '../context';
import { selectProjectDefaultView, selectSavedView } from '../selectors';
import { SavedViewParams } from '../types';

/**
 * This hook covers the logic for applying the saved view's filters
 */
export const useProjectDefaults = () => {
  const history = useHistory();
  const queryParams = useQueryParams();
  const projectDefaultView = useSelector(selectProjectDefaultView);
  const savedView: SavedViewParams = useSelector(selectSavedView);
  const { setSelectedTab } = useTabContext();
  const { viewId } = useViewContext();

  const { defaultTab } = savedView || {};

  useEffect(() => {
    if (defaultTab) {
      setSelectedTab(defaultTab);
    }
  }, [defaultTab]);

  // check if url is a shareable link
  const paramList: string[] = [];
  queryParams.forEach((_, key) => paramList.push(key));
  const urlParamsExist = paramList.some((p) => FilterParamOptions.includes(p));
  const autoSelectDefault = projectDefaultView?.id && !viewId && !urlParamsExist;

  useEffect(() => {
    if (autoSelectDefault) {
      const { id } = projectDefaultView;
      const newPath = `/messagingInsights/views/${id}`;
      history.replace(newPath);
    }
  }, [projectDefaultView]);
};
